
import React, { useContext, useMemo, useState } from "react";
import { Box, Button, Stack, SvgIcon } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { PortalNames } from "common/Portals";

import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AssessmentIcon from '@mui/icons-material/Assessment';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import HelpIcon from '@mui/icons-material/Help';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import GroupsIcon from '@mui/icons-material/Groups';
import HealingIcon from '@mui/icons-material/Healing';
import teamsIcon from 'assets/img/teamsIcon.png';
import { ReactComponent as ShowcaseIcon } from 'assets/img/ShowcaseIcon.svg';

import { apiUrls } from "common/ApiUrls";
import { apiGet } from "app/Services/ApiService";
import PdfViewerModal from "components/PdfViewerModal";
import { Link as RouterLink } from "react-router-dom";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

function isMatch(path) {
    var match = window.location.pathname.match(new RegExp(path, "i"));

    return match !== null;
}

function QuickLinks(props) {
    const { companyId, userInfo, error, feedback } = useContext(PrivateRoutesContext);

    const [isPdfViewerOpen, setIsPdfViewerOpen] = useState(false);
    const [isLoadingDocument, setIsLoadingDocument] = useState(false);
    const [document, setDocument] = useState(null);

    const isGsg = useMemo(() => userInfo?.companyDetails?.groupType === "GSG", [userInfo]);

    const actions = [
        //{ isLink: true, icon: <GroupsIcon />, name: 'Space Co Lab', href: 'https://aximfsg.com', target: "_blank" },
        //{ isLink: true, icon: <HelpIcon />, name: 'Support', href: 'feedback' },
        // { icon: <VerifiedUserIcon />, name: 'DOL Audit', href: 'audit' },
    ];

    if (isMatch(PortalNames.Employer.Path) && userInfo?.companyDetails?.spaceCoLabUri) {
        actions.push({
            isLink: false,
            component: (index) =>{
                return(
                <Button
                    key={`quicklink${index}`}
                    variant="outlined"
                    startIcon={<GroupsIcon />}
                    component={RouterLink}
                    to={`/${PortalNames.Employer.Path}/space-co-lab`}
                >
                    Space Co Lab
                </Button>
                );
            }
        });
    }

    actions.push({
        isLink: false,
        component: (index) => {
            return (
                <Button
                    key={`quicklink${index}`}
                    variant="outlined"
                    startIcon={<HelpIcon />}
                    onClick={() => feedback.setDoShow(true)}
                >
                    Support
                </Button>
            )
        }
    })

    // if (isMatch(PortalNames.Employer.Path) && !isGsg) {
    //     actions.push({
    //         isLink: false,
    //         component: (index) => {
    //             return (
    //                 <LoadingButton
    //                     key={`quicklink${index}`}
    //                     variant="outlined"
    //                     loading={isLoadingDocument}
    //                     loadingPosition="start"
    //                     startIcon={<AssessmentIcon />}
    //                     onClick={() => showLogIQmindReport()}
    //                 >
    //                     LogIQmind
    //                 </LoadingButton>
    //             )
    //         }
    //      });
    // }
    // else if (isMatch(PortalNames.Partner.Path) || isMatch(PortalNames.Broker.Path)) {
    //     actions.push({ isLink: true, icon: <AssessmentIcon />, name: 'LOGIQMIND', href: 'https://prod-useast-a.online.tableau.com/#/site/logiqmind/views/LogIQMind/LogIQMInd-BrokerageMarketBrokerDetailsUpdate?:iid=1', target:"_blank" });
    // }

    // if (userInfo?.companyDetails?.enrollmentPortal === "Ease Central" && !isMatch(PortalNames.Employee.Path))
    // {
    //     actions.push({ isLink: true, icon: <MedicalServicesIcon />, name: 'EASE', href: 'https://secure.ease.com/', target:"_blank" });
    // }
    // actions.push({ icon: <VerifiedUserIcon />, name: 'DOL Audit', href: 'audit' });

    // if (!isMatch(PortalNames.Employee.Path) && isGsg) {
    //     actions.push({ isLink: true, icon: <HealingIcon />, name: 'VHBA/TPA', href: 'https://ebixhub.ebix.com/sso/client/clientlogin.aspx?client=bm', target: '_blank' });
    // }

    // if (userInfo?.companyDetails?.showcaseUri) {
    //     var href = '';

    //     if (isMatch(PortalNames.Employer.Path)) {
    //         href = `${userInfo?.companyDetails?.showcaseUri}Company`;
    //     }
    //     else if (isMatch(PortalNames.Employee.Path)) {
    //         href = `${userInfo?.companyDetails?.showcaseUri}Employee`;

    //     }

    //     if (href) {
    //         actions.push({ isLink: true, icon: <SvgIcon><ShowcaseIcon /></SvgIcon>, name: "Showcase", href: href, target: '_blank'});
    //     }
    // }

    // if (usesTeams) {
    //     actions.push({ isLink: true, icon: <Box component="img" sx={{ maxHeight: "24px", maxWidth: "24px" }} src={teamsIcon} alt="Microsoft Teams" />, name: "Teams", href: "https://teams.microsoft.com/l/channel/19%3a-S5lyEewGCqRlUTh_55V-FCGqdIHwAUV4rpFmQqQPQs1%40thread.tacv2/General?groupId=e9eb5828-e0bf-4f68-9c00-c049e424f5b5&tenantId=fd9b6d1d-4726-46e2-8702-f8b971c205d7", target: "_blank" })
    // }

    const showLogIQmindReport = () => {
        setIsLoadingDocument(true);

        apiGet(apiUrls.getLogIQmindReport(companyId))
            .then((response) => {
                setDocument(response.data);
            })
            .catch((e) => {
                setDocument(null);

                error.setTitle("An Error Occurred");
                error.setText("Unable to display report.");
                error.setDoShowError(true);
            })
            .finally(() => {
                setIsPdfViewerOpen(true);
                setIsLoadingDocument(false);
            });
    }

    return (
        <>
            <Stack spacing={1} direction="row">
                {actions.map((action,index) => {
                    if (action.isLink) {
                        return (
                            <Button
                                key={`quicklink${index}`}
                                href={action.href}
                                startIcon={action.icon}
                                target={action.target}
                                rel="noopener"
                                variant="outlined"
                                color="primary"
                            >
                                {action.name}
                            </Button>
                        )
                    }
                    else {
                        return (action.component(index))
                    }
                })}
            </Stack>
            {document ?
                <PdfViewerModal
                    open={isPdfViewerOpen}
                    documentId={document.documentId}
                    filename={document.filename}
                    description={document.description}
                    contents={document.contents}
                    handleClose={() => {
                        setIsPdfViewerOpen(false);
                        setDocument(null);
                    }}
                    handleDownloadUrl={apiUrls.downloadLogIQmindReport(companyId, document.documentId)}
                />
            : null}
        </>
    )
}

export default QuickLinks
